import { z } from "zod";

export const occurrenceActionSchema = z
  .object({
    reasonId: z.string().min(1, "Motivo é obrigatório"),
    description: z
      .string()
      .min(30, "A descrição deve ter no mínimo 30 caracteres"),
    messageTemplateId: z.string(),
    customMessage: z.string(),
    duplicateProtocol: z.string().optional(),
  })
  .refine(
    (data) => {
      if (data.reasonId === "DUPLICATE" && !data.duplicateProtocol) {
        return false;
      }
      return true;
    },
    {
      message: "Protocolo é obrigatório para ocorrências duplicadas",
      path: ["duplicateProtocol"],
    },
  );

export type OccurrenceActionFormData = z.infer<typeof occurrenceActionSchema>;

export const editOccurrenceSchema = z.object({
  categoryId: z.string().min(1, "Categoria é obrigatória"),
  subcategoryId: z.string().min(1, "Subcategoria é obrigatória"),
  description: z.string().min(10, "Descrição deve ter no mínimo 10 caracteres"),
  sectorId: z.string().min(1, "Setor é obrigatório"),
  priority: z.enum(["LOW", "MEDIUM", "HIGH"], {
    message: "Prioridade é obrigatória",
  }),
});

export type EditOccurrenceFormData = z.infer<typeof editOccurrenceSchema>;
